import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export interface CollectionMethod {
  id?: string;
  method: string;
  price: number;
}

export const useUpdateClinicCollectionMethod = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      collectionMethodId,
      collectionMethod,
    }: {
      collectionMethodId: string;
      collectionMethod: Partial<CollectionMethod>;
    }) => {
      return api.put(`clinic/collection-methods/${collectionMethodId}`, {
        collection_method: collectionMethod.method,
        collection_price: collectionMethod.price,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-collection-method-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.collectionMethods(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Clinic Collection Method]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.collectionMethods(),
      });

      handleErrors(res, "mutation");
    },
  });
};
